import React from "react";

const LocationSection = ({ invitation, mapEmbedUrl, fontStyleMap }) => {
  if (!invitation?.venue_name && !mapEmbedUrl) {
    return null;
  }

  return (
    <section className="fw-section fw-location">
      <div className="fw-location-inner">
        <h2
          className="fw-section-title"
          style={{ ...(fontStyleMap.subtitle || {}) }}
        >
          Локација
        </h2>
        {invitation?.venue_name && (
          <p
            className="fw-location-venue"
            style={{ ...(fontStyleMap.body || {}) }}
          >
            {invitation.venue_name}
          </p>
        )}
      </div>
      {mapEmbedUrl && (
        <div className="fw-location-map">
          <iframe
            title="Google Maps"
            src={mapEmbedUrl}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      )}
    </section>
  );
};

export default LocationSection;

